// extracted by mini-css-extract-plugin
export default {"col":"default_col__hR2-3","content":"default_content__yQgpz","content--left":"default_content--left__3dIsl","content--right":"default_content--right__sSMsC"};